<template>
  <div class="search-release" v-loading="loading" :element-loading-text="$t('loading')" element-loading-background="transparent">
    <div v-if="count">
      <!-- 释放文件 -->
      <Authorization
        :gid="gid"
        authModule="file_content"
        :hasPayment="!showAuth"
        class="indicator"
        :showPoint="false"
        fullScreen
      >
        <template v-slot:payment>
          <ReleaseFile v-if="!loading" releaseOrMendump="dropped" id="releasefile" type="adSearch" :releasefile="releasefile" />
          <div class="pagination-wrap" v-if="!loading">
            <Pagination
              @handleSizeChange="handleSizeChange"
              @handleCurrentChange="handleCurrentChange"
              :totalSize="totalSize"
              :current_page="currentPage"
              :pageSizes="[10, 50]"
              :page-size="pageSize"
              customTotal
            />
          </div>
        </template>
      </Authorization>
    </div>
    <sand-no-data v-if="!count && !loading" :isFullscreen="true"/>
  </div>
</template>

<script>
import { getAdSearchModuleDetail } from 'services/search'
import Pagination from '@/components/common/Pagination'
import ReleaseFile from '@/views/report/ReleaseFile'
import { isZh } from 'app/i18n'
import sandNoData from '@/components/report/sandNoData'
import { mapGetters } from 'vuex'

export default {
  name: 'release',
  components: {
    ReleaseFile,
    Pagination,
    sandNoData
  },
  props: {
    record_id: {
      type: String,
      required: true
    },
    total: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      releasefile: {},
      loading: true,
      currentPage: 1,
      totalSize: this.total,
      pageSize: 10,
      showAuth: false,
      count: window.tabCount.dropped
    }
  },
  computed: {
    ...mapGetters(['gid']),
    taskId() {
      return this.$route.params.taskId
    }
  },
  methods: {
    async init() {
      this.getList()
    },
    async getList() {
      document.querySelector('.explain').scrollTo({
        top: 0
      })
      this.loading = true
      getAdSearchModuleDetail({
        page: this.currentPage,
        size: this.pageSize,
        protocol: 'dropped_info',
        record_id: this.record_id,
        lang: isZh() ? 'zh' : 'en'
      }).then(res => {
        this.loading = false
        if (res.code === 4020 && window.tabCount.dropped) {
          this.showAuth = true
          return
        }
        this.releasefile.dropped = res
      })
    },
    handleSizeChange (size) {
      this.pageSize = size
      this.getList()
    },
    handleCurrentChange (page) {
      this.currentPage = page
      this.getList()
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.search-release {
  min-height: 178px;
  // min-height: 654px;
  :deep(.release-file-wrap) {
    padding-top: 8px;
  }
  & > :deep(.sand-noData) {
    // height: calc(100vh - 305px);
    padding: 56px 0;
  }
  :deep(.sand-noData) {
    // height: calc(100vh - 305px);
    height: auto;
    padding: 56px 0;
  }
  :deep(.release-file-wrap .sand-noData) {
    // height: calc(100vh - 337px);
    padding: 56px 0;
  }
}
.pagination-wrap {
  padding:0 0 12px;
  margin-right: -20px;
}
</style>
